import { DatePipe } from '@angular/common';
import { FilesizePipe } from '@library/core/pipes';

const datePipe = new DatePipe( 'en' );
const filesize = new FilesizePipe();

export const InputErrors = {
   required: _ => 'Required',
   min: ({ min }) => `Minimum value ${min}`,
   max: ({ max }) => `Maxiumum value ${max}`,
   maxlength: ({ requiredLength }) => `Maximum length ${requiredLength}`,
   minlength: ({ requiredLength }) => `Minimum length ${requiredLength}`,
   pattern: _ => `Invalid Value`,
   email: _ => `Invalid Email`,
   matTimepicker: _ => `Invalid Time`,
   matDatepickerFilter: _ => `Invalid Date`,
   dateTimeFilter: _ => `Invalid Date/Time`,
   matDatepickerMin: ({ min }) => `Needs to be after ${datePipe.transform( min, 'shortDate' )}`,
   matDatepickerMax: ({ max }) => `Needs to be before ${datePipe.transform( max, 'shortDate' )}`,
   bothRequired: ({ missing }) => `Missing required field ${missing}`,
   allOf: error => `Missing required field${error.length !== 1 ? 's' : ''} ${error.join(', ')}`,
   filesize: ({ max }) => `Max file size exceeded (Max ${filesize.transform( max )})`,
   custom: ({ string }) => string,
};
